"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSnippetProvider = createSnippetProvider;
function createSnippetProvider(api) {
    return {
        async list(payload, options) {
            const response = await api.snippetList(payload, options);
            return {
                object: 'list',
                data: response.data.data,
            };
        },
        async retrieve(snippetId, options) {
            const response = await api.snippetRetrieve({ snippetId }, options);
            return response.data;
        },
        async create(payload, options) {
            const response = await api.snippetCreate({ snippetCreatePayload: payload }, options);
            return response.data;
        },
        async update(snippetId, payload, options) {
            const response = await api.snippetUpdate({
                snippetId,
                snippetUpdatePayload: payload,
            }, options);
            return response.data;
        },
        async delete(snippetId, options) {
            const response = await api.snippetDelete({ snippetId }, options);
            return response.data;
        },
    };
}
//# sourceMappingURL=snippetProvider.js.map